export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";